
import React from 'react';
import { Button } from "@/components/ui/button";
import { Apple, Download } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

const AppDownloadBanner: React.FC = () => {
  const isMobile = useIsMobile();
  return <div className="relative overflow-hidden rounded-lg bg-white p-6 border border-gray-200">
      <div className="flex flex-col md:flex-row items-center gap-6">
        <div className="md:w-1/2">
          <h2 className="text-2xl font-bold mb-2 text-gray-800">Test Tastermonial!</h2>
          <p className="mb-4 text-gray-600">
            Download the app today to experience Tastermonial first hand with your own experiment.
          </p>

          <div className="flex flex-wrap sm:flex-row gap-3 mt-4">
            <a
              href="https://apps.apple.com/se/app/tastermonial-food-navigator/id1483114134"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <img
                src="/images/appstore_badge.svg"
                alt="Download on the App Store"
                className="h-12 w-auto"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.tastermonial.app&hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <img
                src="/images/play_store_badge.svg"
                alt="Get it on Google Play"
                className="h-12 w-auto"
              />
            </a>
          </div>
        </div>

        <div className="md:w-1/2 flex justify-center">
          <div className={`${isMobile ? "w-32" : "w-48"}`}>
            <img src="/lovable-uploads/3d9b6911-4c1c-4f59-a6aa-9f3e25e993b0.png" alt="Tastermonial Mobile App" className="w-full rounded-lg transform rotate-3" />
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-gray-100/50"></div>
      <div className="absolute top-6 right-20 w-6 h-6 rounded-full bg-gray-100/50"></div>
    </div>;
};
export default AppDownloadBanner;
